<div class="container" style="height: 80vh">
    <div class="toolbar">
        <div class="one-row" style="margin-bottom: 12px" *ngIf="showSupportButton === true">
            <span class="spacer"></span>
            <button
                *kienePermission="[10032]"
                mat-stroked-button
                color="accent"
                (click)="openTicketDialog()"
                [attr.data-cy]="'bbubu_button_1_0_'"
            >
                <mat-icon [attr.data-cy]="'bbubu_mat-icon_1_2_'">support_agent</mat-icon>
                VETVET kontaktieren
            </button>
            <span class="spacer"></span>
        </div>
        <div style="display: flex; align-items: center; justify-content: center">
            <mat-form-field class="mat-form-field-no-padding-margin" style="width: 95%">
                <mat-label>Suche</mat-label>
                <input [formControl]="searchCtrl" matInput placeholder="Suche" [attr.data-cy]="'bbubu_input_1_1_'" />
            </mat-form-field>
        </div>
        <div style="display: flex; align-items: center; justify-content: space-between">
            <mat-slide-toggle
                (change)="filterUnread($event.checked)"
                [checked]="true"
                style="padding-left: 6px"
                [attr.data-cy]="'bbubu_toggle_1_1_'"
                >Nur ungelesene anzeigen
            </mat-slide-toggle>
            <button
                (click)="markAllAsRead()"
                [disabled]="allRead() || isSaving"
                color="accent"
                mat-icon-button
                matTooltip="Alle als gelesen markieren"
                [attr.data-cy]="'bbubu_button_2_0_'"
            >
                <mat-icon [attr.data-cy]="'bbubu_mat-icon_2_2_'">done_all</mat-icon>
            </button>
        </div>
    </div>

    <div
        *ngIf="benachrichtigungen.length === 0 && !onlyUnreadBenachrichtigungen && isLoading"
        style="color: #777; display: flex; align-items: center; justify-content: center; width: 100%; height: 75vh"
    >
        <mat-hint> Lade Benachrichtigungen...</mat-hint>
    </div>

    <div
        *ngIf="benachrichtigungen.length === 0 && !isLoading"
        style="color: #777; display: flex; align-items: center; justify-content: center; width: 100%; height: 75vh"
    >
        <mat-hint> Keine Benachrichtigungen</mat-hint>
    </div>

    <div
        *ngIf="benachrichtigungen.length === 0 && onlyUnreadBenachrichtigungen"
        style="color: #777; display: flex; align-items: center; justify-content: center; width: 100%; height: 75vh"
    >
        <mat-hint> Keine ungelesenen Benachrichtigungen</mat-hint>
    </div>

    <div *ngIf="benachrichtigungen.length > 0">
        <!--<div style="height: 65vh; overflow-y: auto" infinite-scroll [infiniteScrollDistance]="2"
    [infiniteScrollUpDistance]="1.5" (scrolled)="scrolled()" [scrollWindow]="false">-->
        <div style="height: 65vh; overflow-y: auto">
            <div
                (click)="markAsRead(nachricht)"
                *ngFor="let nachricht of benachrichtigungen; let i = index"
                class="notification-item"
                [class.notification-item--clickable]="isLink(nachricht)"
            >
                <div
                    style="width: 15%; display: flex; align-items: center; justify-content: center; margin: 0 3px 0 3px"
                >
                    <div class="acronym-icon">
                        <mat-icon color="primary" [attr.data-cy]="'bbubu_mat-icon_3_2_' + i">{{
                            benachrichtigungsTyp[nachricht.typ]
                        }}</mat-icon>
                    </div>
                </div>

                <div style="width: 80%" [attr.data-cy]="'bbubu_notification_' + i">
                    <strong>{{ nachricht.titel }}</strong>
                    <div class="one-row">
                        <span [attr.data-cy]="'bbubu_notification_txt_' + i">{{ nachricht.txt }}</span>
                        <mat-icon *ngIf="isLink(nachricht)" [attr.data-cy]="'bbubu_mat-icon_4_2_' + i"
                            >chevron_right</mat-icon
                        >
                    </div>
                    <div style="width: 100%; text-align: right; color: #777; font-size: 0.8em">
                        {{ formatDate(nachricht.erstellt) }}
                    </div>
                </div>
                <div style="width: 5%; display: flex; align-items: center; justify-content: center">
                    <div *ngIf="nachricht.gelesen == 0" class="unread-dot"></div>
                </div>
            </div>
        </div>
    </div>
</div>
